<template>
  <div class="bg-white-wrapper">
    <div class="container payment-wrapper">
      <h3 class="payment-header">
        <img src="../../assets/images/shoppimg-pay.png" /> &nbsp;购买付款
      </h3>
      <div class="payment-info">
        <div class="payment-text">
          订单提交成功，去付款喽~
          <span class="text-secondary"
            >请尽快完成支付，支付完成后可立即学习</span
          >
        </div>
        <!-- 支付方式 -->
        <div class="payment-method-wrapper">
          <h5 class="payment-method-title">请选择支付方式</h5>
          <div class="payment-method">
            <span
              :class="{ selected: currentPayment == item.type }"
              v-for="(item, index) in paymentList"
              :key="index"
              @click="changePayment(item)"
            >
              <i>
                <img src="../../assets/images/pay-logo-sed.png" alt="pay" />
              </i>
              <img
                v-if="item.type == 3"
                src="../../assets/images/pay-logo-union.png"
                alt="pay"
              />
              <img
                v-else-if="item.type == 2"
                src="../../assets/images/pay-logo-alipay.png"
                alt="pay"
              />
              <img
                v-else-if="item.type == 1"
                src="../../assets/images/pay-logo-wx.png"
                alt="pay"
              />
            </span>
          </div>
        </div>
        <!-- 分期付款 -->
        <div class="payment-method-wrapper" v-show="false">
          <div
            class="payment-method-stage clearfix"
            style="cursor:pointer;"
            @click="stagePay"
          >
            <i>
              <img src="../../assets/images/stage-check.png" v-if="!isStage" />
              <img src="../../assets/images/stage-checked.png" v-else />
            </i>
            <div>
              <img src="../../assets/images/stage-logo.png" />
              <p style="font-size:18px; color:#666; margin-top:6px;">
                首付金额￥{300}，借款金额￥{400}
              </p>
            </div>
          </div>
          <div class="payment-method-stage-code" v-show="isStage">
            <span style="display:inline-block;vertical-align:middle;">
              <input type="text" name="redeemCode" placeholder="请输入申请码" />
            </span>
            <span @click="stageHelperVisible = true">什么是申请码？</span>
          </div>
        </div>
        <!-- 订单信息 -->
        <div class="payment-method-wrapper">
          <h5 class="payment-method-title">订单信息</h5>
          <div class="payment-order">
            <p>
              <b>订单编号：</b>
              <span>{{ orderInfo.orderNo }}</span>
            </p>
            <p>
              <b>应付总额：</b>
              <span class="payment-money"
                >￥{{ orderInfo.orderMoney.toFixed(2) }}</span
              >
            </p>
          </div>
        </div>
        <div class="payment-submit">
          <Button
            type="primary"
            class="payment-submit-btn fr"
            size="large"
            shape="circle"
            @click="payOrder"
            >确认支付</Button
          >
        </div>
      </div>
    </div>
    <div v-html="alipayForm" ref="alipayWrapper"></div>
    <Modal
      v-model="payModelVisible"
      :closable="false"
      :mask-closable="false"
      width="360"
      class-name="vertical-center-modal"
    >
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span style="margin-left:0.5rem;">确定付款</span>
      </p>
      <b style="font-size:1.6rem">请在新打开的页面上完成付款</b>
      <p>&nbsp;</p>
      <p>付款完成前请不要关闭此窗口</p>
      <p>完成付款后请根据你的情况点击下面的按扭</p>
      <div slot="footer" style="text-align:center">
        <Button
          type="error"
          size="large"
          @click="payFail"
          style="margin-right:30px;"
          >付款失败</Button
        >
        <Button type="success" size="large" @click="paySuccess"
          >完成付款</Button
        >
      </div>
    </Modal>

    <Modal v-model="stageHelperVisible" width="1200" footer-hide>
      <div class="stage-helper">
        <img src="../../assets/images/stage-progress.png" />
      </div>
    </Modal>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import {
  getOrderInfo,
  savePayQrcode,
  removeOrderInfo,
} from "../../utils/localStorage";
import { order } from "../../request";
export default {
  mixins: [siteMixin],
  data() {
    return {
      stageHelperVisible: false,
      isStage: false,
      orderInfo: {
        orderNo: "",
        orderMoney: 0,
      },
      paymentList: [],
      currentPayment: 0,
      alipayForm: "",
      payModelVisible: false,
    };
  },
  mounted() {
    this.initOrderInfo();
    this.getPaymentList();
  },
  methods: {
    initOrderInfo() {
      this.orderInfo = getOrderInfo();
      //console.log(this.orderInfo);
    },
    getPaymentList() {
      order.getPaymentType(this.siteConfig.agencyId).then((res) => {
        //console.log(res);
        if (res.status == 1) {
          var list = res.data;
          this.paymentList = list;
          if (this.paymentList.length > 0) {
            this.currentPayment = this.paymentList[0].type;
            //只有个人二维码时的逻辑处理
            if (this.currentPayment == 4) {
              let qrcode = {
                wxqr: "",
                aliqr: "",
                payTel: "",
              };
              this.paymentList[0].url.forEach((item) => {
                if (item.name == "微信二维码") {
                  qrcode.wxqr = item.wxqr;
                  qrcode.payTel = item.payTel;
                }
                if (item.name == "支付宝二维码") {
                  qrcode.aliqr = item.aliqr;
                  qrcode.payTel = item.payTel;
                }
              });
              savePayQrcode(qrcode);
              this.$router.push({ name: "PaymentQrcode" });
            }
          }
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    changePayment(item) {
      this.currentPayment = item.type;
    },
    payOrder() {
      switch (this.currentPayment) {
        case "1":
          this.$router.push({ name: "PaymentWx" });
          break;
        case "2":
          order
            .paymentWithAlipay(this.loginUser.userId, this.orderInfo.orderNo)
            .then((res) => {
              if (res.status == 1) {
                this.payModelVisible = true;
                this.alipayForm = res.data;
                removeOrderInfo();
                this.$nextTick(() => {
                  this.$refs.alipayWrapper.children[0].setAttribute(
                    "target",
                    "_blank"
                  );
                  this.$refs.alipayWrapper.children[0].submit();
                });
              } else {
                this.$Message.error("请求支付接口错误");
              }
            });
          break;
        case "3":
          this.$router.push({ name: "PaymentUnion" });
          break;
        default:
          this.$router.push({ name: "Home" });
          break;
      }
    },
    paySuccess() {
      // this.$router.push({ name: "MemberCenter" });
      this.$router.push({ name: "PaymentSuccess" });
    },
    payFail() {
      this.$router.push({ name: "MemberOrder" });
    },
    //分期付款
    stagePay() {
      this.isStage = !this.isStage;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var";
.payment-wrapper {
  padding: 10px 0;
  .payment-header {
    color: #000;
    font-size: 2rem;
    font-weight: normal;
    padding: 1.6rem 0;
    img {
      .inline-block();
      width: 50px;
      margin-top: -4px;
    }
  }
  .payment-info {
    padding: 30px 50px;
    background-color: #fff;
    border: 1px solid #f0f0f0;
    text-align: left;
    .payment-text {
      .text-secondary {
        color: #3bb4f2;
      }
    }
    // 支付信息
    .payment-method-wrapper {
      padding: 20px 0;
      .payment-method-title {
        padding: 10px 0;
        border-bottom: 1px solid #f4f4f4;
        font-size: 1.8rem;
      }
      .payment-method {
        margin-top: 1.2rem;
        span {
          position: relative;
          border: 1px solid #dcdcdc;
          color: #505050;
          width: 220px;
          height: 160px;
          padding: 40px 10px;
          display: inline-block;
          margin-right: 10px;
          cursor: pointer;
          overflow: hidden;
          vertical-align: middle;
          text-align: center;
          i {
            position: absolute;
            left: 0;
            top: 0;
            display: inline-block;
            width: 71px;
            height: 66px;
            overflow: hidden;
            display: none;
          }
          &:not(.no-pay):hover {
            border-color: #999;
          }
          &:not(.no-pay).selected {
            border-color: #0095d3;
            i {
              display: inline-block;
            }
          }
        }
      }
      .payment-method-stage {
        & > i {
          float: left;
          margin-top: 5px;
        }
        & > div {
          float: left;
          margin-left: 10px;
          p {
            font-size: 1.8rem;
            color: #666;
            margin-top: 6px;
          }
        }
      }
      .payment-method-stage-code {
        margin-left: 43px;
        margin-top: 16px;
        // display: none;
        span {
          input {
            width: 260px;
            height: 42px;
            padding: 0 6px;
            line-height: 42px;
            outline: none;
            border: 1px solid #ccc;
            border-radius: 8px;
            font-size: 16px;
            background-color: #f6f7f8;
          }
          &:last-child {
            cursor: pointer;
            color: #ff6a00;
            font-size: 1.8rem;
            margin-left: 16px;
          }
        }
      }
      .payment-order {
        margin-top: 1.6rem;
        p {
          line-height: 3rem;
          .payment-money {
            font-size: 2.4rem;
            color: #1296db;
          }
        }
      }
    }
    // 支付按扭
    .payment-submit {
      padding-bottom: 20px;
      .payment-submit-btn {
        width: 180px;
        border: none;
        outline: none;
        background: -webkit-linear-gradient(left, #3ec2ff, #258aff);
      }
    }
  }
}
.stage-helper {
  width: 100%;
  img {
    width: 100%;
  }
}
</style>
